import { useState, useEffect } from 'react';

export const useWindowHeight = () => {
	const [height, setHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => {
			setHeight(window.innerHeight);
		};

		window.addEventListener('resize', handleResize);

		// Clean up the event listener on component unmount
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return height;
};



// WEBPACK FOOTER //
// ./src/hooks/useWindowHeight.js